// Contenido de shared/wrapPageElement.js
import React from "react";
import CoreErrorBoundary from "./core-error-boundary";

export const wrapPageElement = ({ element, props }) => {
    return <CoreErrorBoundary {...props}>{element}</CoreErrorBoundary>;
};
